import { render, staticRenderFns } from "./DueDateRuleFields.yaml?vue&type=template&id=2242b038&component"
import script from "./DueDateRuleFields.yaml?vue&type=script&lang=ts&component"
export * from "./DueDateRuleFields.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports